<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <add-parties
          :show="showAddPartiesPopup"
          :currentTemplateId="currentTemplateId"
          @finish="onfinish"
        ></add-parties>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('PersianName') },
                { title: $t('NotificationTitle') },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.persianName }}
                </td>
                <td style="width: 30%">
                  {{ row.subject }}
                </td>
                <td style="width: 35%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="simple-bordered-btn"
                    @click.prevent="isAddPartiesPopup(row)"
                    >{{ $t("AddNewRecipient") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";
import AddParties from "./AddPartiesPopup.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
export default {
  name: "",
  components: {
    DataGrid,
    AddParties
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Notifications/api/NotificationTemplate"
      },
      gridSearchData: {},
      showAddPartiesPopup: false,
      currentTemplateId: ""
    };
  },
  methods: {
    isAddPartiesPopup(template) {
      this.currentTemplateId = template.id;
      this.showAddPartiesPopup = true;
    },
    onfinish() {
      this.showAddPartiesPopup = false;
      this.$refs.grid.renderGrid();
    }
  }
};
</script>

<style></style>
